import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "../../styles/admin/BatchForm.scss";

const BatchForm = ({ isOpen, onClose, onSubmit, initialData }) => {
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: "",
  });

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Batch name is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const payload = {
      name: formData.name.trim(),
    };
    onSubmit(payload);
  };

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || initialData.title || "",
      });
    } else {
      setFormData({ name: "" });
    }
  }, [initialData, isOpen]);
  
  return (
    <div className="batch-form-overlay">
      <div className="batch-form-container">
        <div className="batch-form-header">
          <h2>{initialData ? "Edit" : "Create"} Batch</h2>
          <button
            className="batch-close-button"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="batch-form">
          <div className={`batch-form-group ${errors.name ? "has-error" : ""}`}>
            <label htmlFor="batch-name">Batch Name</label>
            <input
              id="batch-name"
              type="text"
              value={formData.name}
              onChange={(e) =>
                setFormData((p) => ({ ...p, name: e.target.value }))
              }
              placeholder="Enter batch name"
              aria-invalid={!!errors.name}
              aria-describedby={errors.name ? "batch-name-error" : undefined}
            />
            {errors.name && (
              <span id="batch-name-error" className="batch-error-message">
                {errors.name}
              </span>
            )}
          </div>

          <div className="batch-form-actions">
            <button
              type="button"
              className="batch-cancel-button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="batch-submit-button btn-interactive"
            >
              {initialData ? "Update" : "Create"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BatchForm;
